export enum WaffleFlags {
  IsOddjobEnabled = 'oddjob',
  IsSurfaceToModelComparisonEnabled = 'surface_to_model_comparison',
  ShowSurfacelogDeltaHeightLegendConfigurationUi2 = 'show_surfacelog_delta_height_legend_configuration_ui2',
  ShowSurfacelogVolumeCalculations = 'show_surfacelog_volume_calculations',
}